import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/ContactUs/Banner'
import Form from '../Component/ContactUs/Form'
import Footer from '../Component/NavBarFooter/Footer'

function ContactUs() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <Form/>
        <Footer/>
    </div>
  )
}

export default ContactUs